import React from 'react';
import { AutocompleteInput, useRecordContext, useTranslate } from 'react-admin';


const StatusInput = ({ source = 'status', ...props }) => {
	const record = useRecordContext(props);
	const translate = useTranslate();

	if (!record) {
		return null;
	}

	const choices = [
		{ id: 'draft', name: translate('Draft') },
		{ id: 'sent', name: translate('Sent') },
		{ id: 'view', name: translate('View') },
		{ id: 'paid', name: translate('Paid') }
	];

	return (
		<AutocompleteInput choices={choices} source={source} record={record} {...props} />
	);
};

export default StatusInput;
